import { render, staticRenderFns } from "./OwnersInfo.vue?vue&type=template&id=925fe046&scoped=true&"
import script from "./OwnersInfo.vue?vue&type=script&lang=js&"
export * from "./OwnersInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925fe046",
  null
  
)

export default component.exports